// extracted by mini-css-extract-plugin
export var avatarContainer = "_fm-0";
export var gray = "_fm-f";
export var green = "_fm-c";
export var icon = "_fm-9";
export var image = "_fm-1";
export var lg = "_fm-6";
export var md = "_fm-5";
export var presenceDot = "_fm-b";
export var red = "_fm-d";
export var sm = "_fm-4";
export var status = "_fm-a";
export var xl = "_fm-7";
export var xs = "_fm-3";
export var xxl = "_fm-8";
export var xxs = "_fm-2";
export var yellow = "_fm-e";